/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import { formatDateWithFullTime, getUserFromId } from '../../globalUtils/globalHooks';
import './UpdateLogsSidePopover.css'
import CustomAvatar from '../../globalUtils/CustomAvatar/CustomAvatar';
import { IUpdateLogs } from '../../rmsReduxStore/advanceRuleEngineRedux/advanceRuleEngineType';

interface UpdateLogsSidePopoverProps {
  ruleId: string
  updateLogs: IUpdateLogs[]
}

/*eslint-disable @typescript-eslint/no-unused-vars*/

const UpdateLogsSidePopover = ({ ruleId,updateLogs }: UpdateLogsSidePopoverProps) => {
  return (
    <div className='update__log__container'>
    { updateLogs?.length ===0 ? <div className='update__log__no__data'>No Data</div> :
        updateLogs?.map((item,index) => {
        return (
            <div key = {index} className='update__log__individual__row'>
                <CustomAvatar containerClassName='update__logs__user__icon' diameter={20} titleText={getUserFromId(item?.userId) ?? 'System Admin'} hideText={true} />
                <div className='d-flex gap-4' dangerouslySetInnerHTML={{__html: item?.logEntry ?? ''}} style={{width:'100%',flexWrap: 'wrap'}}></div>
                <div style={{display: 'flex',justifyContent: 'flex-end',width: '32%'}}>
                {formatDateWithFullTime(item?.createdAt)}
                </div>
            </div>
        )  
    })
    }
    </div>
  );
};

export default memo(UpdateLogsSidePopover);